export const BASE_URL = 'project-messages';
